import React from "react";
import "./DropdownInputs.scss";

const DropdownInputs = ({
  title,
  type,
  value,
  onChange,
  name,
  options,
  placeholder,
  maxLength,
  multiple,
  error,
  disabled, 
  ...props
}) => {
  return (
    <div className="dropdownInputs">
      <span className="title">{title}</span>
      <select
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxLength}
        multiple={multiple}
        
        disabled={disabled} 
      >
        <option selected>Please Select</option>
        {options?.map((option, index) => (
          <option key={index} value={option?.value}>
            {option?.label}
          </option>
        ))}
      </select>
      <span className="error">{error}</span>
    </div>
  );
};

export default DropdownInputs;
